import { connect } from 'react-redux';
import { injectIntl } from 'react-intl';
import { getToastNotifications } from '@app/selectors/toastsSelectors';

import Notifications from '@chama/ui-components/components/Notifications';

function mapStateToProps(state, ownProps) {
  const {
    intl: { formatMessage },
  } = ownProps;

  const messageToText = message => {
    if (typeof message === 'string') return message;
    return formatMessage({ id: message.id });
  };

  const notifications = getToastNotifications(state)
    .filter(toastNotification => toastNotification && toastNotification.message)
    .map(({ id, message, type }) => ({
      id,
      text: messageToText(message),
      icon: type,
    }));

  return {
    notifications,
  };
}

export default injectIntl(connect(mapStateToProps)(Notifications));



// WEBPACK FOOTER //
// ./src/containers/ToastNotifications.jsx